import { gql } from 'graphql-request'

export const ItemPastaFragment = gql`
  fragment ItemPastaFragment on ItemBiblioteca {
    id
    nome
    isPasta
    isPublico
    pastaPai {
      id
    }
    proprietario {
      id
      nome
      email
    }
    permissoesAcessoUsuarioLogado {
      id
      description
    }
    permissoes {
      id
      grupoUsuarios {
        id
        nome
        favorito
      }
      permissaoAcessoPasta {
        id
      }
    }
    arquivo {
      id
      nome
    }
    ultimaModificacao
    dataCriacao
    arquivoLink
    arquivoMiniaturaLink
    arquivoImagem
  }
`
